// Read the active brand once at mount.
//
// Brand is decided by host + ?brand= query (see utils/branding.ts).
// We resolve it in a useState initializer so the value is stable for the
// lifetime of the component — switching brands requires a full reload,
// which matches how favicons/titles are set in the index.html bootstrap.

import { useState } from 'react';
import {
  BRANDS,
  detectBrandKey,
  type BrandAssets,
  type BrandKey,
} from '../utils/branding';

export type UseBrandResult = {
  key: BrandKey;
  assets: BrandAssets;
};

export default function useBrand(): UseBrandResult {
  const [key] = useState<BrandKey>(() => detectBrandKey());
  return { key, assets: BRANDS[key] };
}
